import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { FontAwesomeIcon } from 'atoms/icons';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineL, LabelM } from 'atoms/typography';
import { glossary } from 'lib/glossary';

const Content = styled(Vertical).attrs({ gap: 2 })`
  align-items: flex-start;
  height: 100%;
`;

const Actions = styled(Vertical).attrs({ gap: 0 })`
  flex-grow: 1;
  width: 100%;
  justify-content: flex-end;
`;

export const Confirmation = ({ onClick }: { onClick: () => void }) => {
  return (
    <Content>
      <FontAwesomeIcon size="2xl" icon={faClock} />
      <HeadlineL as="h3">
        <FormattedMessage
          id="UnblockWallet.Confirmation.title"
          defaultMessage="We’re reviewing your documents"
        />
      </HeadlineL>
      <LabelM>
        <FormattedMessage
          id="UnblockWallet.Confirmation.descriptionNotify"
          defaultMessage="We’ll notify you once we validate your documents."
        />
      </LabelM>
      <LabelM>
        <FormattedMessage
          id="UnblockWallet.Confirmation.meantime"
          defaultMessage="In the meantime, you can pick up right where you left off."
        />
      </LabelM>
      <Actions>
        <Button fullWidth size="medium" color="primary" onClick={onClick}>
          <FormattedMessage {...glossary.done} />
        </Button>
      </Actions>
    </Content>
  );
};
